import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

/* Local store */
import { localStoreFN } from '../../store/localStorage';
import ObjGeneral from '../function';

/* Actions */
import * as loginactions from '../../actions/login/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*locale*/
import String from '../../components/locales';

/*Styles*/
import '../../../../public/style/login.scss';

/*img */
import Logo from '../../../../public/images/logo-gauss.png';

class LoginCallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogged: false,
      redirectLogin: false
    };
  }

  componentDidMount() {
    if (this.props.match.params.lang) {
      String.setLanguage(this.props.match.params.lang);
      this.props.dashboardActions.handleLanguageChange(String);
    }

    // check if the user is previously authenticated
    const auth = localStoreFN().getItem('auth');
    this.setState({ isLogged: auth === 'true'});

    setTimeout(() => {
      this.handleLoginSSO();
    }, 1500);
  }

  /**
   * login with code returned by Auth0
   */
  handleLoginSSO = async () => {
    const href = window.location.href.replace('#', '?');
    const url = new URL(href);
    const params = url.searchParams;
    const code = params.get('code');
    await this.props.actions.saveLoginSSOApi({ code });
  };

  /**
   * return to login
   */
  handleRedirectLogin = () => {
    this.props.actions.resetLogin();
    this.setState({ redirectLogin: true });
  }

  render() {
    const auth = this.props.auth || this.state.isLogged;

    // if the API returns an error message, it displays it in the console
    if (this.props.message) {
      console.log('API error =>', this.props.message);
    }

    // check if the user is authenticated and if redirection data is available
    if (ObjGeneral.shouldRedirectFromUrl(this.props.history, auth)) {
      return null;
    }

    // if the login is successful, it redirects you to the dashboard
    if (auth) {
      return <Redirect to="/dashboard" />
    }

    // if an error occurred in the login and press the back button, it redirects to the login
    if (this.state.redirectLogin) {
      return <Redirect to="/" />
    }

    return (
      <div className="container_login">
        <div className="container_login_box" style={{ maxWidth: '50rem' }}>
          <div className="container_login_img">
            <img src={Logo} alt="Gauss control" />
          </div>
          <div className="messageSSO">
            {
              // shows message while validating Auth0 return code
              (this.props.token === null) && (
                <h3>{this.props.language.login.main.validating}</h3>
              )
            }

            {
              // If the validation gives an error, a message and a button are displayed to return to the login
              (this.props.message || this.props.token === false) && (
                <div className="box-form top topx2 center">
                  <h3>{this.props.language.login.main.errorLoginlSSO}</h3>
                  <input type="button" className="login mt-2" value={this.props.language.login.main.backToLogin} onClick={this.handleRedirectLogin} />
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.reducer.login.auth,
  loading: state.reducer.login.loading,
  message: state.reducer.login.message,
  token: state.reducer.login.token,
  language: state.reducer.dashboard.language
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(loginactions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

LoginCallback.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginCallback);



// WEBPACK FOOTER //
// ./source/client/containers/login_callback/index.jsx